import { Link } from 'react-router';
import { useWorkspace, type ActiveWorkspace } from '../../../lib/session';
import { useUserChecklist } from './api';
import styles from './SetupBanner.module.css';

/**
 * One line above „Meine Tasks" while a checklist is visible (own element, no frame): the personal progress
 * („Einrichtung · 6 von 8 erledigt") or the open organization setup, with the link to `/setup/checklist`.
 */
export function SetupBanner() {
  // Sessions recorded before M8 (fixtures of older specs) carry no `onboarding`: no banner then.
  const onboarding = useWorkspace().onboarding as ActiveWorkspace['onboarding'] | undefined;
  const userVisible = onboarding?.userChecklistVisible === true;
  const visible = userVisible || onboarding?.organizationChecklistVisible === true;
  const checklist = useUserChecklist(userVisible);
  if (!visible) return null;
  const text =
    userVisible && checklist.data
      ? `Einrichtung · ${checklist.data.progress.done} von ${checklist.data.progress.total} erledigt`
      : userVisible
        ? 'Einrichtung · noch nicht abgeschlossen'
        : 'Die Einrichtung der Organisation läuft noch.';
  return (
    <div className={styles.banner} role="status">
      <span className={styles.dot} aria-hidden="true" />
      <span className={styles.text}>{text}</span>
      <Link to="/setup/checklist" className={styles.link}>
        Zur Checkliste
      </Link>
    </div>
  );
}
